import styled from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy'

import { NextLink } from '../../../../../navigation/NextLink'

import { sectionGap } from './styles'

export const SectionHeader = styled.div`
  align-items: center;
  display: flex;
  gap: ${o => o.theme.spacing(4)};
  justify-content: space-between;
`

/** Groups a subtitle with the grid it heads, so sibling grids stay visually separated. */
export const SizingTable = styled.div`
  ${sectionGap};
  display: flex;
  flex-direction: column;
`

export const TableHeaderRow = styled.div`
  align-items: center;
  display: flex;
  gap: ${o => o.theme.spacing(2)};
  justify-content: space-between;
`

export const TableHeaderLabel = styled(TypeStyle.BodyNano)`
  font-weight: 700;
`

export const SizePreferencesLink = styled(NextLink)`
  ${TypeStyle.css.bodyNano};
  color: ${o => o.theme.color.text.secondary.on.background};
  font-weight: 600;
  text-decoration: underline;
`
